const NAME_PATTERN = /^[A-Za-z0-9_\-\s]{3,50}$/

export const validatePortfolioName = (name) => {
  return name.match(NAME_PATTERN)
}

export function isSamePortfolio(currentPath, alias, id) {
  const { portfolioIdOrAlias } = getPortfolioAndLocationFromPath(currentPath)
  if (!portfolioIdOrAlias) {
    return false
  }

  return portfolioIdOrAlias === id || portfolioIdOrAlias === alias
}

export function getPortfolioAndLocationFromPath(currentPath) {
  const pathParts = currentPath.split("/")

  if (pathParts.length < 4 || pathParts[2] !== "p") {
    return {}
  }

  const portfolioIdOrAlias = pathParts[3]
  const location = `${pathParts[4] || ""}${pathParts[5] ? `/${pathParts[5]}` : ""}`

  return {
    portfolioIdOrAlias,
    location,
  }
}
